import {query} from "app/gql/client";
import {
  type ValueFragment,
  RevalidateControlCardValueDocument,
  SaveControlCardValueDocument,
  type ValueInstanceFragment
} from "app/gql/graphqlSchema";
import {useCallback, useState} from "react";
import {useControlCardInstanceContext} from "app/employee/controlCard/ControlCardInstanceContext";

export const useSaveControlCardValue = (valueInstance: Pick<ValueInstanceFragment, "id">) => {
  const {instance, updateValues} = useControlCardInstanceContext();
  const [saving, setSaving] = useState(false);
  const saveValue = useCallback(
    async (newValue: ValueFragment) => {
      setSaving(true);
      try {
        const result = await query(SaveControlCardValueDocument, {
          input: {
            newValue: JSON.stringify(newValue),
            valueIds: [valueInstance.id],
            instanceId: instance.id
          }
        });
        const updatedValues = result.controlCardInstanceUpdateValue.values;
        updateValues(updatedValues);
      } finally {
        setSaving(false);
      }
    },
    [valueInstance, instance.id, updateValues]
  );

  const revalidateValue = useCallback(async () => {
    setSaving(true);
    try {
      const result = await query(RevalidateControlCardValueDocument, {
        input: {
          valueIds: [valueInstance.id],
          instanceId: instance.id
        }
      });
      const updatedValues = result.controlCardInstanceRevalidateValue.values;
      updateValues(updatedValues);
    } finally {
      setSaving(false);
    }
  }, [valueInstance, instance.id, updateValues]);
  return {saveValue, revalidateValue, saving} as const;
};
